<script>
    import ChevronRight from 'lucide-svelte/icons/chevron-right';

    export let appName = '';
    export let rootPath = '/';
    export let paths = [];
</script>

<nav class="breadcrumbs">
    <a href={rootPath} class="app-name">{appName}</a>
    <div class="breadcrumbs__path-section">
        {#each paths.slice(0, -1) as path, index}
            <span class="breadcrumbs__item" aria-describedby={index === paths.length - 2 ? 'current-page' : undefined}>
                {#if index === paths.length - 2}
                    {path.label}
                {:else}
                    <a href={path.path}>{path.label}</a>
                    <ChevronRight />
                {/if}
            </span>
        {/each}
    </div>
</nav>

<style lang="scss">
    .app-name {
        color: inherit;
        font-size: 24px;
        font-weight: bold;

        @media only screen and (width >= 48em) {
            margin-right: var(--spacing0);
        }
    }

    .breadcrumbs {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        margin-bottom: var(--spacing-1);
        color: inherit;
    }

    .breadcrumbs__item {
        vertical-align: middle;
    }

    .breadcrumbs__item + .breadcrumbs__item::before {
        display: none;
    }

    .breadcrumbs__item a {
        color: inherit;
    }

    .breadcrumbs__item-link {
        color: inherit;
    }

    .breadcrumbs__item + .breadcrumbs__item::before {
        display: inline;
        font-weight: normal;
    }
</style>
